import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function LoadingError() {
  const { t } = useTranslation();

  return (
    <Typography color='error'>
      {t('readingView.menu.navigation.bookDetails.error')}
    </Typography>
  );
}
